require('./agentLogin.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const classNames = require('classnames');

const { getLanguage } = require('core/i18n').i18n;

// @ helpers
const {saveAgentLoginInfo} = require('utilities/contactCenter/disasterRecoveryhelper');
const {handleOnEnter} = require('utilities/contactCenter/keyBoardHelper');

// @ constants
const {
    TRANSLATION_PLATFORM_PRI,
    TRANSLATION_PLATFORM_CC
} = require('constants/translations');

// @ components
const { formatText, FormattedText } = require('core/i18n').i18n;
const { InputSafe } = require('commonsComponents/inputSafe');
const { OKButton } = require('components/commons/OKButton/OKButton');

class AgentLogin extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleUserChange = this.handleUserChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.state = {
            userAgent: '',
            passwordAgent: ''
        }
    }

    componentWillMount() {
        const { requestTranslations } = this.props;
        requestTranslations( __CONTACT_CENTER__ ? TRANSLATION_PLATFORM_CC : TRANSLATION_PLATFORM_PRI, getLanguage())
    }

    componentWillReceiveProps(nextProps) {
        const bankToken = nextProps.immAgentLogin.get('bankToken');
        const inOffice = nextProps.immAgentLogin.get('inOffice');
        const agentId = this.state.userAgent;
        if((nextProps.immAgentLogin.get('success') !== this.props.immAgentLogin.get('success')) && nextProps.immAgentLogin.get('success')) {
            saveAgentLoginInfo({bankToken, agentId, inOffice});
            this.props.history.push('/disasterRecovery/customerFinder')
        }
    }

    handleClick () {
        const { requestAgentCredentials } = this.props;
        const agentUser = this.state.userAgent;
        const agentPassword = this.state.passwordAgent;

        requestAgentCredentials(agentPassword, agentUser);
    }

    handleUserChange(evt) {
        this.setState({
            userAgent: evt.target.value
        });
    }

    handlePasswordChange(evt) {
        this.setState({
            passwordAgent: evt.target.value
        });
    }


    verifyData() {
        const agentUser = this.state.userAgent;
        const agentPassword = this.state.passwordAgent;

        return !(agentUser && agentPassword);
    }

    render(){

        const {immAgentLogin } = this.props;

        const flagError = !!immAgentLogin.get('error');
        const flagConnect = flagError ? immAgentLogin.get('error').get('description') === "Connection Error" : flagError;
        const messageConnect = "agentAuthentication-errorMessageConnect";
        const messageError = "agentAuthentication-errorMessage";
        const tryAgainConnect = "agentAuthentication-tryAgainMessageConnect";
        const tryAgain = "agentAuthentication-tryAgainMessage";
        const isFetching = immAgentLogin.get('isFetching');

        const tryAgainMessageClass = classNames(
            'agent-login__try-again',
            {'agent-login__try-again--visible': flagError}
            );

        return (
            <div className="agent-login">
                <div className="agent-login__inputs">
                    <i className="agent-login__key"/>
                    <h3 className="agent-login__title">
                        {formatText('agentAuthentication-userDataLabel')}
                    </h3>
                    <InputSafe
                        id="txtAgentUser"
                        className="agent-login__input-user"
                        type="text"
                        label={formatText('agentAuthentication-userLabel')}
                        autoComplete="off"
                        value={this.state.userAgent}
                        onChange={this.handleUserChange}
                    />
                    <InputSafe
                        id="txtAgentPassword"
                        type="password"
                        label={formatText('agentAuthentication-passwordLabel')}
                        autoComplete="off"
                        errorState={flagError}
                        errorMessage={formatText(flagConnect ? messageConnect : messageError)}
                        value={this.state.passwordAgent}
                        onChange={this.handlePasswordChange}
                        onKeyUp={(evt) =>{handleOnEnter(evt, this.handleClick)}}
                    />
                    <FormattedText
                        value={flagConnect ? tryAgainConnect : tryAgain}
                        className={tryAgainMessageClass}
                    />
                    <OKButton
                        modifier="primary"
                        onClick={this.handleClick}
                        disabled={this.verifyData()}
                        loading={isFetching}
                    >
                        {formatText('agentAuthentication-confirmButton')}
                    </OKButton>
                </div>
            </div>
        );
    }
}

AgentLogin.propTypes = {
    history: PropTypes.object.isRequired,
    immAgentLogin: PropTypes.object.isRequired,
    immTranslations: PropTypes.object.isRequired,
    requestAgentCredentials: PropTypes.func.isRequired,
    requestTranslations: PropTypes.func.isRequired
};

module.exports.AgentLogin = withRouter(AgentLogin);
